export enum AboASubType {    
    Unknown = 1,
    A1 = 2,
    A2 = 3
}